module.exports = __webpack_public_path__ + "static/media/breast.e6a2f45b.svg";